export enum ApiScope {
  PRODUCTS_READ = "products:read",
  PRODUCTS_WRITE = "products:write",
}
